import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * Interfaz que modela cada registro (7 columnas) de tu nuevo endpoint POST
 *  1) Prefix              => item.nlri
 *  2) Family             => item.family
 *  3) Neighbour          => item.neighbor
 *  4) Local preference   => item.localpreference
 *  5) Community          => item.community
 *  6) Extended community => item.extendedcommunity
 *  7) Direction          => item.type
 */
export interface BgpTables {
    prefix: string;              // item.nlri
    family: string;             // item.family
    neighbor: string;           // item.neighbor
    localPref: string;          // item.localpreference
    community: string;          // item.community
    extendedCommunity: string;  // item.extendedcommunity
    direction: string;          // item.type
}

/**
 * Columnas para la tabla (7):
 *  1) Prefix
 *  2) Family
 *  3) Neighbour
 *  4) Local preference
 *  5) Community
 *  6) Extended community
 *  7) Direction
 */
export const tablesColumns: GenericTableColumn<BgpTables>[] = [
    {
        header: "Prefix",
        accessor: "prefix",
    },
    {
        header: "Family",
        accessor: "family",
    },
    {
        header: "Neighbour",
        accessor: "neighbor",
    },
    {
        header: "Local preference",
        // Se llama "localPref" en la interfaz
        accessor: "localPref",
    },
    {
        header: "Community",
        accessor: "community",
    },
    {
        header: "Extended community",
        accessor: "extendedCommunity",
    },
    {
        header: "Direction",
        accessor: "direction",
    },
];
